import React, { useState } from 'react';
import '../styles/Descargar.css';

const Descargar = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  const handleDownloadCsv = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/contactos/export-csv`, {
        method: 'GET',
        headers: {
          'Accept': 'application/zip',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al descargar el archivo');
      }

      // Obtener el blob del archivo ZIP
      const blob = await response.blob();

      // Crear URL temporal para el blob
      const url = window.URL.createObjectURL(blob);

      // Crear elemento <a> temporal para descargar
      const link = document.createElement('a');
      link.href = url;

      // Obtener el nombre del archivo de la respuesta o usar uno por defecto
      const contentDisposition = response.headers.get('Content-Disposition');
      let fileName = 'contactos_' + new Date().toISOString().slice(0, 19).replace(/:/g, '-') + '.zip';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      link.download = fileName;

      // Simular click para descargar
      document.body.appendChild(link);
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log('Archivo descargado exitosamente:', fileName);

    } catch (error) {
      console.error('Error al descargar CSV:', error);
      setError(error.message || 'Error al descargar el archivo');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="main-content">
      <div className="descargar-container">
      <div className="descargar-header">
        <h1>Descargar Contactos</h1>
        <p>Descargue el archivo CSV con todos los contactos registrados</p>
      </div>

      <div className="descargar-content">
        <div className="info-card">
          <h3>Información del archivo</h3>
          <ul>
            <li>El archivo se descargará en formato ZIP protegido con contraseña</li>
            <li>Contiene todos los contactos registrados en el sistema</li>
            <li>El archivo CSV puede abrirse en Excel o cualquier editor de hojas de cálculo</li>
            <li>Solicite la contraseña al administrador del sistema</li>
          </ul>
        </div>

        {error && (
          <div className="error-alert">
            <strong>Error:</strong> {error}
          </div>
        )}

        <button
          className="download-btn"
          onClick={handleDownloadCsv}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="spinner"></span>
              Descargando...
            </>
          ) : (
            <>
              <span className="download-icon">⬇</span>
              Descargar CSV
            </>
          )}
        </button>
      </div>
    </div>
    </main>
  );
};

export default Descargar;
